import React from "react";
import moment from "moment";
import {
  disableSignatoryButton,
  disableUpdateButton,
  getSignatoryRoleLabel,
  isSignatoryApprovable,
} from "../../../../../utils/formGenUtils/approvalUtils";
import {
  BtnDanger,
  BtnSuccess,
  SignedOffBy,
  SignatoryContainer,
  SignatoryCommentContainer,
  SignatoryHeading,
  SignatoryComment,
  ApprovalContainer,
  ApprovalTitleContainer,
  ApprovalTitle,
  ApprovalStatusContainer,
  ApprovalStatus,
  ApprovalButtonContainer,
} from "./style";
import { ActionType } from "../..";

interface IApprovalListProps {
  data: any[];
  handleClick: () => void;
  userRole: string;
  userId: string;
  setComment: (value: string) => void;
  isQAPIDisabled?: boolean;
  hasUserSigned: boolean;
  setAction: (action: ActionType | "") => void;
  setIncidentSignatureId: (id: string) => void;
  isActionLoading: boolean;
  isStatusValid: boolean;
  isConclusionFilled?: boolean;
  hasSecondLevelSigned?: boolean;
}

const ApprovalList = ({
  data,
  handleClick,
  userRole,
  userId,
  isQAPIDisabled,
  hasUserSigned,
  setAction,
  setComment,
  setIncidentSignatureId,
  isActionLoading,
  isStatusValid,
  isConclusionFilled,
  hasSecondLevelSigned,
}: IApprovalListProps) => {
  const conclusionFilled = !!isConclusionFilled;
  const sharedApprovalOpts = {
    isQAPILevel: !!isQAPIDisabled,
    isQAPIDisabled: !!isQAPIDisabled,
    userSignedOff: hasUserSigned,
    isActionLoading,
    isConclusionFilled: conclusionFilled,
    isStatusValid,
  };
  const isUpdateDisabled = isActionLoading || !conclusionFilled;
  const isResetDisabled =
    hasSecondLevelSigned === true || isActionLoading || !conclusionFilled;
  function handleButtonClick(
    action: ActionType,
    incidentSignatureId: string,
    comment?: string | undefined
  ) {
    handleClick();
    setAction(action);
    setComment(comment ?? "");
    setIncidentSignatureId(incidentSignatureId);
  }

  return (
    <div className="py-10">
      {data.map((item: any) => {
        const portalRoleName = item.Contact_on_Facility__r?.Portal_Role__r?.Name;

        return (
          <React.Fragment key={item.Facility_Signature_Requirement__c}>
          <ApprovalContainer>
            {/* Approver's Title container */}
            <ApprovalTitleContainer>
              <ApprovalTitle>
                {getSignatoryRoleLabel(item.Eligible_Signers__c)}
              </ApprovalTitle>
            </ApprovalTitleContainer>
            {/* end of Approver's Title container */}
            {/* Approval Status container */}
            <ApprovalStatusContainer>
              <ApprovalStatus>
                {" "}
                {item.Status__c || "Awaiting Approval"}
              </ApprovalStatus>
            </ApprovalStatusContainer>
            {/* end of Approval Status container */}
            {/* Approval Button container */}
            <ApprovalButtonContainer>
              {!item.Status__c ? (
                <BtnSuccess
                  data-testid={`approve-btn-${item.Eligible_Signers__c}`}
                  onClick={() => handleButtonClick(ActionType.Approve, item.Id)}
                  disabled={!isSignatoryApprovable(item, userRole, sharedApprovalOpts)}
                >
                  {isActionLoading ? "Approving" : "Approve"}
                </BtnSuccess>
              ) : (
                <BtnSuccess
                  data-testid={`edit-btn-${item.Eligible_Signers__c}`}
                  onClick={() =>
                    handleButtonClick(ActionType.Edit, item.Id, item.Comment__c)
                  }
                  disabled={
                    isUpdateDisabled || disableUpdateButton(item, userId)
                  }
                >
                  {isActionLoading ? "Updating" : "Update"}
                </BtnSuccess>
              )}
              {!item.Status__c ? (
                <BtnDanger
                  data-testid={`reject-btn-${item.Eligible_Signers__c}`}
                  onClick={() =>
                    handleButtonClick(
                      ActionType.Reject,
                      item.Id,
                      item.Comment__c
                    )
                  }
                  disabled={!isSignatoryApprovable(item, userRole, sharedApprovalOpts)}
                >
                  {isActionLoading ? "Rejecting" : "Reject"}
                </BtnDanger>
              ) : (
                <BtnDanger
                  data-testid={`reset-btn-${item.Eligible_Signers__c}`}
                  onClick={() =>
                    handleButtonClick(
                      ActionType.Reset,
                      item.Id,
                      item.Comment__c
                    )
                  }
                  disabled={
                    isResetDisabled || disableUpdateButton(item, userId)
                  }
                >
                  {isActionLoading ? "Resetting" : "Reset"}
                </BtnDanger>
              )}
            </ApprovalButtonContainer>
          </ApprovalContainer>
          {item.Status__c && (
            <SignatoryContainer>
              <SignedOffBy>
                Signed Off by {item.Signed_By_Name_Text__c}
                {portalRoleName && ` (${portalRoleName})`} |{" "}
                {item?.Signed_Date_Time__c &&
                  moment(item.Signed_Date_Time__c).format("MM/DD/YYYY")}{" "}
                |{" "}
                {item?.Signed_Date_Time__c &&
                  moment(item.Signed_Date_Time__c).format("kk:mm")}
              </SignedOffBy>
              {item.Comment__c && (
                <SignatoryCommentContainer>
                  <SignatoryHeading>Comment:</SignatoryHeading>
                  <SignatoryComment>{item.Comment__c}</SignatoryComment>
                </SignatoryCommentContainer>
              )}
            </SignatoryContainer>
          )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ApprovalList;
